import { getCheckout, State as CheckoutState } from "./checkout";
import { MaybeEmpty, VERIFICATION_TARGET } from "../../../../../constants";
import { VerificationState } from "../../../../../models/state";

export type State = CheckoutState;

export const getVerification = (state: State): MaybeEmpty<VerificationState> => getCheckout(state).verification || {};
export const isProductUserVerified = (state: State): boolean =>
    !!getVerification(state)[VERIFICATION_TARGET.TRANSFER_OWNERSHIP_TO_B2C];
export const isLegalOwnerVerified = (state: State): boolean =>
    !!getVerification(state)[VERIFICATION_TARGET.FORMER_LEGAL_OWNER_CONSENT_TRANSFER_B2B];
export const isLegalOwnerConsentRequired = (state: State): boolean =>
    !!getVerification(state).isLegalOwnerConsentRequired;
export const canProductUserProceed = (state: State): boolean =>
    isProductUserVerified(state) && (!isLegalOwnerConsentRequired(state) || isLegalOwnerVerified(state));
export const successfullySetPersonalDetails = (state: State): boolean =>
    !!getVerification(state).setPersonalDetailsSuccess;
export const successfullySetAccountId = (state: State): boolean => !!getVerification(state).setSelectedAccountIdSuccess;
export const successfullySubmittedManualOrder = (state: State): boolean =>
    !!getVerification(state).submitManualOrderSuccess;
export const isAllowedToProceed = (state: State): boolean => getVerification(state).isAllowedToProceed || false;
export const isOrdererDifferantThanLegalOwner = (state: State): boolean =>
    !!getVerification(state).isOrdererDifferantThanLegalOwner;
export const isDsfMismatch = (state: State): boolean => !!getVerification(state).isDsfMismatch;
export const getBankIdDetails = (state: State) => getVerification(state).bankIdDetails;

// Credit Check
export const isCreditCheckRequired = (state: State): boolean => !!getVerification(state).isCreditCheckRequired;
export const creditCheckMessage = (state: State): string => getVerification(state).creditCheckMessage || "";
export const isCreditCheckPerformed = (state: State): boolean => !!getVerification(state).isCreditCheckPerformed;
